'use client';

import chevronDown from '@iconify/icons-carbon/chevron-down';
import chevronUp from '@iconify/icons-carbon/chevron-up';
import { RouteAnchorController } from '@larvitu/shared/next/utils';
import { Box, Fade } from '@mui/material';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';


import { ActiveLink, FadeTransition, Iconify } from '../..';
import { Popper } from '../../../compounds';

import type { LinkProps } from '@mui/material';
import type { FC, ReactNode } from 'react';

interface NavItemChildProps {
  subheader: string;
  cover?: string;
  items?: Array<{
    title: string;
    path: string;
  }>;
}

interface NavItemProps {
  title: string;
  path: string;
  children?: NavItemChildProps[];
}

export interface NavItemDesktopProps {
  item: NavItemProps;
  isScrolling: boolean | undefined;
  isTransparent: boolean | undefined;
}

interface SubLinkProps extends LinkProps {
  path: string;
  isActiveRoot?: boolean;
  isScrolling?: boolean;
  isTransparent?: boolean;
  isOpen?: boolean;
  children: ReactNode;
}

const SubLink: FC<SubLinkProps> = (
  { children, path, isOpen, isActiveRoot, isScrolling, isTransparent, ...props } // <NextLink href={path} passHref>
) => (
  <ActiveLink
    href={path}
    active={isActiveRoot}
    scrolling={isScrolling}
    transparent={isTransparent}
    {...props}
  >
    {children}
    <Iconify
      icon={isOpen ? chevronUp : chevronDown}
      sx={{
        ml: 0.5,
        width: 16,
        height: 16,
      }}
    />
  </ActiveLink>
);

// <NextLink>;

export interface NavigationDropdownLinkProps extends Omit<NavItemDesktopProps, 'item'> {
  children: ReactNode;
  title: string;
  path: string;
}

export const NavigationDropdownLink: FC<NavigationDropdownLinkProps> = ({
  title,
  path,
  isScrolling,
  isTransparent,
  children,
}) => {
  const { pathname, asPath } = useRouter();

  const [open, setOpen] = useState( true );

  const isActiveRoot = path === pathname || (path !== '/' && asPath.includes( path ));
  const handleClose = (): void => {
    setOpen( false );
  };

  useEffect( () => {
    if (open) {
      handleClose();
    }
  }, [open, pathname] );

  return (
    <RouteAnchorController>
      <Popper transition placement="bottom" disablePortal>
        <Popper.Leave>
          <Popper.OnClickClose>
            <span style={{ position: 'relative' }}>
              <Popper.Enter>
                <Popper.IsOpen>
                  <SubLink
                    path={path}
                    isActiveRoot={isActiveRoot}
                    isScrolling={isScrolling}
                    isTransparent={isTransparent}
                  >
                    {title}
                  </SubLink>
                </Popper.IsOpen>
              </Popper.Enter>
              <Popper.Display>
                <FadeTransition timeout={550}>
                  {/*{( { TransitionProps } ): JSX.Element => (*/}
                  {/*  <Fade {...TransitionProps} timeout={550}>*/}
                  <Box
                    position="absolute"
                    sx={{
                      left: 0,
                      top: isScrolling ? 40 : 50,
                      width: '100vw',
                      transition: 'top 1.4s ease 0s',
                    }}
                  >
                    {children}
                  </Box>
                  {/*  </Fade>*/}
                  {/*)}*/}
                </FadeTransition>
              </Popper.Display>
            </span>
          </Popper.OnClickClose>
        </Popper.Leave>
      </Popper>
    </RouteAnchorController>
  );
};
